<template>
    <div v-if="templateArgs.btns" class="text-center">
		<hr>
		<div class="btn-group m-0" role="group" aria-label="Btns group">
            <div v-for="btn in templateArgs.btns" :key="btn.name">
				<button
					type="button"
					@click="btn.clickHandler(templateArgs)"
					:title="btn.tooltip"
					data-toggle="tooltip"
					:class="btn.class"
					:data-placement="!btn.tooltipPlacement ? 'top' : btn.tooltipPlacement"
					v-if="btn.show"
				>
					<i :class="btn.icon"></i>
					{{btn.text}}
				</button>
			</div>
        </div>

    </div>
</template>

<script>

export default {
	name: "headerTemplate",
	props: {},
    data() {
        return {
			templateArgs: {},
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style>
</style>
